import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',
      alignItems: 'stretch',
    },
    locked: {},
    headerWrapper: {
      backgroundColor: '#F7F9FD',
      padding: theme.spacing(2.5, 4.5, 4),
      borderTop: `1px solid ${COLORS.neutral.lightGray}`,
    },
    header: {},
    body: {
      position: 'relative',
      padding: theme.spacing(2.5, 4.5, 0),
    },
    blurred: {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'flex-start',
      inset: 0,
      backdropFilter: 'blur(5px)',
      '& $blockedMessage': {
        backgroundColor: COLORS.neutral.white,
      },
    },
    blockedMessage: {
      marginTop: theme.spacing(4.5),
    },
    textEditorWrapper: {
      position: 'relative',
    },
    textEditor: {
      marginTop: theme.spacing(1.5),
    },
    editingActions: {
      position: 'absolute',
      right: theme.spacing(1),
      bottom: theme.spacing(1),
    },
    histograms: {},
    divider: {
      backgroundColor: theme.palette.dividerLightBlue,
      margin: theme.spacing(2, 0, 2, 0),
    },

    mainAnnotations: {},
    contentSensitivity: {},
  }),
  { name: 'TextDetailsPanel' }
);
